<template>
  <el-card shadow="never" class="info-card">
    <el-row>
      <el-col :span="2" class="item-text">当前工站：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_name }}</el-col>
      <el-col :span="2" class="item-text">SN：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.sn }}</el-col>
      <el-col :span="2" class="item-text">原产品：</el-col>
      <el-col :span="8" class="item-value">{{ busItem.from_product_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">当前工站状态：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_status_name }}</el-col>
      <el-col :span="2" class="item-text">品类：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.catalog_name }}</el-col>
      <el-col :span="2" class="item-text">目标产品：</el-col>
      <el-col :span="8" class="item-value">{{ busItem.to_product_name }}</el-col>
    </el-row>
    <el-row>
      <el-col :span="2" class="item-text">当前工站责任人：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.current_station_user_name }}</el-col>
      <el-col :span="2" class="item-text">订单号：</el-col>
      <el-col :span="4" class="item-value">{{ busItem.order_no }}</el-col>
    </el-row>

  </el-card>
</template>

<script>
export default {
  name: "StationInfo",
  props: {
    busItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style scoped>
.el-row {
  line-height: 32px;
}

.info-card {
  margin-top: 10px;
}

.info-card .el-row {
  display: flex;
}

.item-text {
  text-align: right;
}

.item-value {
  color: goldenrod;
}

.item-value.red-tip {
  color: red;
}

.table-header {
  background-color: #ECECECFF;
}
</style>